import { Stack, SvgIcon, Typography } from "@mui/material";
import { TrueffortChip } from "../../MUIstyle/MUICustom";

export default function Limit({ isMax, total, estimatedVal, label, disabled, handle, title }:
  Readonly<{ isMax?: boolean, total: number, estimatedVal: number, label: string, disabled: boolean, handle: any, title?:string }>) {

  return (
    <Stack direction="column" spacing={0} alignItems="center" justifyContent="center" >
      {!title && <Typography variant='caption' >
        {isMax ? "Más σ" : "Menos σ"}
      </Typography>}
      {title && <Typography variant='caption' >
        {title}
      </Typography>}

      <TrueffortChip
        icon={
          isMax == undefined ? null :
          <SvgIcon >
            {isMax ?
              <svg
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 4.5H10.5V5.5H6V4.5ZM6 6.5H9.5V7.5H6V6.5ZM6 2.5H11.5V3.5H6V2.5ZM6 8.5H8.5V9.5H6V8.5ZM3 10H4V4H5.5L3.5 2L1.5 4H3V10Z"
                  fill={
                    total === estimatedVal ?
                      'white' :
                      '#6693CB'
                  }
                />
              </svg> : <svg
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3.5 10.5L5.5 8.5H4V2.5H3V8.5H1.5L3.5 10.5ZM6 4.5H10.5V5.5H6V4.5ZM6 6.5H9.5V7.5H6V6.5ZM6 2.5H11.5V3.5H6V2.5ZM6 8.5H8.5V9.5H6V8.5Z"
                  fill={
                    total === estimatedVal ?
                      'white' :
                      '#6693CB'
                  }
                />
              </svg>}
          </SvgIcon>
        }
        size='small'
        color='secondary'
        variant={
          total === estimatedVal ?
            'filled' :
            'outlined'
        }
        label={label}
        disabled={disabled}
        onClick={() => handle(estimatedVal)}
      />
    </Stack>
  );
}